// extracted by mini-css-extract-plugin
export default {"imageWrapper":"IN-z","twoColumnImage":"JN-z"};